<template>
  <a-dialog
    persist
    max-width="700px"
    :value="value"
    @input="$emit('input', $event)"
  >
    <span slot="header" class="headline" v-text="passwordHardReset()" />
    <a-form slot="body" ref="form" autocomplete="off" @submit="save">
      <validation-provider
        v-slot="{ errors }"
        :rules="passwordValidationRules()"
        vid="input.password"
      >
        <a-form-group
          id="newpassword"
          slot="body"
          :label="$t('Config.UserProfile.ChangePassword.NewPassword')"
        >
          <a-text-input
            v-model="password"
            :label="passwordFieldLabel()"
            :error-messages="errors"
            :type="inputType"
            :icon-class="showPasswordIcon"
            counter
            autocomplete="off"
            @icon-clicked="showPassword = !showPassword"
          />
        </a-form-group>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        rules="required|password-confirmed:input.password"
        vid="input.passwordRepeat"
      >
        <a-form-group
          id="repeatedPassword"
          slot="body"
          :label="$t('Config.UserProfile.ChangePassword.ConfirmPassword')"
        >
          <a-text-input
            v-model="repeatedPassword"
            :label="passwordRepeatFieldLabel()"
            :error-messages="errors"
            :type="inputrepeatedType"
            :icon-class="showRepeatedPasswordIcon"
            autocomplete="off"
            @icon-clicked="showRepeatedPassword = !showRepeatedPassword"
          />
        </a-form-group>
      </validation-provider>
      <a-password-polices :policies="passwordPolicies" class="mb-3" />
      <div slot="formButtons">
        <button
          class="btn btn-pf-secondary"
          type="button"
          @click="closeDialog()"
          v-text="passwordResetAbort()"
        />
        <button
          class="btn btn-pf-primary"
          type="submit"
          v-text="passwordHardResetExecute()"
        />
      </div>
    </a-form>
  </a-dialog>
</template>

<script>
import Dialog from "+/components/dialog/Dialog";
import Form from "+/components/form/Form";
import FormGroup from "+/components/form/formGroup/FormGroup";
import TextInput from "+/components/form/textInput/TextInput";
import PasswordPolicies from "+/components/passwordPolicies/PasswordPolicies";
import { ValidationProvider } from "vee-validate";
import SetPasswordMutation from "../graphql/SetPasswordMutation.gql";

export default {
  components: {
    "a-dialog": Dialog,
    "a-password-polices": PasswordPolicies,
    "validation-provider": ValidationProvider,
    "a-form": Form,
    "a-form-group": FormGroup,
    "a-text-input": TextInput
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    passwordPolicies: {
      type: Array,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    password: "",
    repeatedPassword: "",
    showPassword: false,
    showRepeatedPassword: false
  }),
  computed: {
    inputType() {
      return this.showPassword ? "text" : "password";
    },
    inputrepeatedType() {
      return this.showRepeatedPassword ? "text" : "password";
    },
    showPasswordIcon() {
      return this.showPassword ? "fa-eye" : "fa-eye-slash";
    },
    showRepeatedPasswordIcon() {
      return this.showRepeatedPassword ? "fa-eye" : "fa-eye-slash";
    }
  },
  methods: {
    passwordHardReset() {
      return this.$t("Security.UserAdministration.PasswordHardReset");
    },
    passwordFieldLabel() {
      return this.$t("Security.UserAdministration.PasswordFieldLabel");
    },
    passwordRepeatFieldLabel() {
      return this.$t("Security.UserAdministration.PasswordRepeatFieldLabel");
    },
    passwordHardResetExecute() {
      return this.$t("Security.UserAdministration.PasswordHardResetExecute");
    },
    passwordResetAbort() {
      return this.$t("Security.UserAdministration.PasswordResetAbort");
    },
    save() {
      this.$apollo
        .mutate({
          client: "security",
          mutation: SetPasswordMutation,
          variables: {
            input: {
              id: this.user.id,
              password: this.password
            }
          }
        })
        .then((response) => {
          if (this.$refs.form.setErrorsIfExsists(response)) {
            this.closeDialog();
            this.resetPasswordSuccess();
          }
        });
    },
    resetPasswordSuccess() {
      const successMessage = this.$t(
        "Security.UserAdministration.PasswordHardResetSuccess"
      );
      this.$feedback(successMessage, {
        type: "success"
      });
    },
    reset() {
      this.password = "";
      this.repeatedPassword = "";
      this.$refs.form.resetFormValidation();
    },
    closeDialog() {
      this.reset();
      this.$emit("input", false);
    },
    passwordValidationRules() {
      return {
        required: true,
        "password-policies-respected": this.passwordPolicies
      };
    }
  }
};
</script>
